import Vue from 'vue';
import SpineWidthCalculator from './components/SpineWidthCalculator.vue';
import QuickQuoteForm from './components/Form.vue';

window.Vue = Vue;

// new Vue({
// 	el: '#book-calculator',
// 	render: h => h(QuickQuoteForm)
// });

new Vue({
	el: '#spine-width-calculator',
	render: h => h(SpineWidthCalculator)
});


// WEBPACK FOOTER //
// ./src/main.js